module.exports = __webpack_public_path__ + "img/Vector.15ec93d3.svg";